import { CompletionRoutes, TestCompletionRoutes } from "@/enums/routes/CompletionRoutes.ts";
import { ExpeditionRoutes, TestExpeditionRoutes } from "@/enums/routes/ExpeditionRoutes.ts";
import { PalletCheckerRoutes, TestPalletCheckerRoutes } from "@/enums/routes/PalletCheckerRoutes";
import { PickingRoutes, TestPickingRoutes } from "@/enums/routes/PickingRoutes.ts";
import router from "@/router";

// Define a type for valid route names
type PickingRouteName = keyof typeof PickingRoutes;
type ExpeditionRouteName = keyof typeof ExpeditionRoutes;
type PalletCheckerRouteName = keyof typeof PalletCheckerRoutes;
type CompletionRouteName = keyof typeof CompletionRoutes;

export const goToPickingRoute = async (name: string, params = {}): Promise<void> => {
    const routeName = name as PickingRouteName;
    const appsMode = localStorage.getItem("appsMode") || "production";
    const route = appsMode === "production" ? PickingRoutes[routeName] : TestPickingRoutes[routeName];
    await router.push({ name: route, params });
};

export const goToExpeditionRoute = async (name: string, params = {}): Promise<void> => {
    const routeName = name as ExpeditionRouteName;
    const appsMode = localStorage.getItem("appsMode") || "production";
    const route = appsMode === "production" ? ExpeditionRoutes[routeName] : TestExpeditionRoutes[routeName];
    await router.push({ name: route, params });
};

export const goToPalletCheckerRoute = async (name: string, params = {}): Promise<void> => {
    const routeName = name as PalletCheckerRouteName;
    const appsMode = localStorage.getItem("appsMode") || "production";
    const route = appsMode === "production" ? PalletCheckerRoutes[routeName] : TestPalletCheckerRoutes[routeName];
    await router.push({ name: route, params });
};

export const goToCompletionRoute = async (name: string, params = {}): Promise<void> => {
    const routeName = name as CompletionRouteName;
    const appsMode = localStorage.getItem("appsMode") || "production";
    const route = appsMode === "production" ? CompletionRoutes[routeName] : TestCompletionRoutes[routeName];
    await router.push({ name: route, params });
};
